import React from 'react';
import * as Api from '../../lib/Api/';
import { ClaimPodcast } from '../AddPodcast/ClaimPodcast';
import { ERROR, LOADING, SUCCESS } from '../../store/selectors';

type Status = 'ERROR' | 'LOADING' | 'SUCCESS';

interface Props {
  redactedEmailAddress: string;
  showId: string;
  onSuccessfulValidation(): void;
}

export function ClaimPodcastContainer(props: Props) {
  let [emailStatus, setEmailStatus] = React.useState<undefined | Status>();
  let [verificationStatus, setVerificationStatus] = React.useState<undefined | Status>();

  function unsetAllTheThings() {
    /**
     * both email status and verification status need to be set to undefined
     * in order for the user to land back on the "send code" view.
     */
    setEmailStatus(undefined);
    setVerificationStatus(undefined);
  }

  async function sendVerificationEmail() {
    try {
      setEmailStatus(LOADING);
      await Api.claimSoundtrapPodcast(props.showId);
      setEmailStatus(SUCCESS);
    } catch {
      /**
       * Send user to next step regardless of errors because there is
       * a retry link on the next step.
       */
      /* istanbul ignore next */
      setEmailStatus(SUCCESS);
    }
  }

  async function checkVerificationCode(_showId: string, code: string) {
    try {
      setVerificationStatus(LOADING);
      await Api.checkVerificationCode({ showId: props.showId, code });
      setVerificationStatus(SUCCESS);
      props.onSuccessfulValidation();
    } catch {
      setVerificationStatus(ERROR);
    }
  }

  return (
    <ClaimPodcast
      redactedEmailAddress={props.redactedEmailAddress}
      showId={props.showId}
      sendVerificationEmail={sendVerificationEmail}
      sendVerificationEmailStatus={emailStatus}
      checkVerificationCode={checkVerificationCode}
      checkVerificationCodeStatus={verificationStatus}
      resetVerificationCodeStatus={unsetAllTheThings}
      isSoundtrapPodcast
      onVerificationSuccess={() => {}}
      claimExistingShow
    />
  );
}
